import { useAuth } from 'react-oidc-context';

export const useReferralUrl = (): string => {
  const auth = useAuth();
  const userId = auth.user?.profile?.user_profile_id as string | undefined;

  if (!auth.isAuthenticated || !userId || typeof window === 'undefined') return '';

  return `${window.location.host}/landing/combo?utm_source=referral_${userId}`;
};
